require('../css/main.css');
import 'alpinejs';

if (!!document.getElementById("js-trading-results")){
    import(/* webpackChunkName: "trading-results" */ './trading-results.js')
        .then(module => {module.default()});
}

if (!!document.getElementById("js-charts-home")){
    import(/* webpackChunkName: "charts-home" */ './charts-home.js')
        .then(module => {module.default()});
}

if (!!document.getElementById("js-charts-aggregated")){
    import(/* webpackChunkName: "charts-aggregated" */ './charts-aggregated.js')
        .then(module => {module.default()});
}

if (!!document.getElementById("js-fullwidth-slider")){
    import(/* webpackChunkName: "fullwidth-slider" */ './fullwidth-slider.js')
        .then(module => {module.default()});
}

if (!!document.getElementById("js-countdown")){
    import(/* webpackChunkName: "countdown" */ './countdown.js')
        .then(module => {module.default()});
}
